module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": _vm.$t('category.label')
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newItem.from.category),
      expression: "newItem.from.category"
    }],
    staticClass: "form-select",
    attrs: {
      "columns": 3
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newItem.from, "category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.$t('choose.label')))]), _vm._v(" "), _vm._l((_vm.from.categories), function(category, index) {
    return (_vm.showItem[index]) ? _c('option', {
      key: category,
      domProps: {
        "value": category
      }
    }, [_vm._v(_vm._s(category))]) : _vm._e()
  })], 2)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "l-col-6@md"
  }, [_c('div', {
    staticClass: "l-row"
  }, _vm._l((_vm.to.categories), function(categories, index) {
    return _c('form-group', {
      key: categories,
      attrs: {
        "label": ((_vm.$t('category.label')) + " " + (_vm.$t('level.label')) + " " + ((index + 1))),
        "columns": 6
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newItem.to.categories[index]),
        expression: "newItem.to.categories[index]"
      }],
      staticClass: "form-select",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.newItem.to.categories, index, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.getCategoryChildren(index, _vm.newItem.to.categories[index])
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": null
      }
    }, [_vm._v(_vm._s(_vm.$t('choose.label')))]), _vm._v(" "), _vm._l((categories), function(category) {
      return _c('option', {
        key: category,
        domProps: {
          "value": category
        }
      }, [_vm._v(_vm._s(category.name))])
    })], 2)])
  }), 1)]), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-col-1@md vertical-center"
  }, [_c('i', {
    staticClass: "i-arrow icon-arrow-right center"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-414d2c0a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/presets/ecommerce/moovin/marketplace/shopee/CategorizationAddItem.vue
// module id = 3091
// module chunks = 0